
(function () {
  var popup = document.querySelector('[data-size-guide-popup]');
  var openButtons = document.querySelectorAll('[data-size-guide-open]');
  var closeButtons = document.querySelectorAll('[data-size-guide-close]');

  if (!popup) return;

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openPopup();
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closePopup();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });
})();